<template>
<b-container>

    <b-row>
      <b-col>
        <BaseSelector v-model="preferredLanguage" 
            :v="$v.preferredLanguage"
            label="What is your preferred language?"
            :options=languageOptions
            tip=""
            slug="language"/>

      </b-col>
    </b-row>

    <b-row v-if="false">
      <b-col>
        <BaseEventSelector v-model="eventId" 
            :v="$v.eventId"
            :label="$t('labels.event')"
            tip=""
            slug="eventId"/>

      </b-col>
    </b-row>
</b-container>

</template>

<script>
import { required, email, minLength, maxLength, numeric, requiredUnless, requiredIf } from 'vuelidate/lib/validators'
import { commonOptions } from '@/mixins/commonOptions.js'
import axios from 'axios'
export default {
    mixins: [
       commonOptions
    ],
  data: () => ({
    preferredLanguage: 'en',
    event: { },
    eventId: '',
  }),

  validations() {
    return {
      preferredLanguage: { required },
      eventId: { required },
      form: [ 'preferredLanguage', 'eventId' ]
    }
  },
  watch: {
    preferredLanguage() {
      this.$i18n.locale = this.preferredLanguage;
      this.$root.$i18n.locale = this.preferredLanguage;
    },

    eventId() {
      this.loadEvent()
    }
  },

  methods: {
     loadEvent() {
      axios.get(`${process.env.VUE_APP_API_BASE_URL}/events`)
        .then(response => { 
          response.data.forEach(location => {
            if (location.id === this.eventId) {
              this.event = location
            }
          })
        })
    },

    validate() {
      this.$v.form.$touch();
      var isValid = !this.$v.form.$invalid
      this.$emit('on-validate', this.$data, isValid)
      this.$i18n.locale = this.preferredLanguage;
      this.$root.$i18n.locale = this.preferredLanguage;
      return isValid
    }

  }
}
</script>

<style>

</style>
